var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgRuby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6156 10.5888L1.42673 20.9972C-0.423361 22.8873 -0.483257 25.8953 1.30029 27.8519L31.9799 61.6461C33.5971 63.4296 36.3988 63.4296 38.0227 61.6461L68.7023 27.8519C70.4792 25.8953 70.4259 22.8873 68.5758 20.9972L58.3803 10.5888C56.7632 8.9317 54.5404 8 52.2311 8H17.7648C15.4488 8 13.2327 8.9317 11.6156 10.5888Z",
    fill: "#E8513D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9946 8L16.3739 28.5108H53.622L34.9946 8Z",
    fill: "#FFBF9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3739 28.5107L33.5039 62.052C34.1228 63.2699 35.8598 63.2699 36.4854 62.052L53.6154 28.5107H16.3739Z",
    fill: "#C12938"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7754 28.5107H16.3739L23.4016 42.2667C24.2801 43.9837 26.7291 43.9837 27.6076 42.2667L32.8783 31.9447C33.6769 30.3808 32.5389 28.5107 30.7754 28.5107Z",
    fill: "#961836"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5692 20.9972L58.3803 10.5888C57.6217 9.81681 56.7299 9.20455 55.7649 8.77197L53.622 28.5174L67.897 25.2764C69.2813 24.9636 70.0799 23.413 69.4144 22.1619C69.1881 21.7426 68.9086 21.3499 68.5692 20.9972Z",
    fill: "#C12938"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.622 28.5108L61.9275 26.6207C62.8791 26.4078 63.2185 25.2365 62.5397 24.5377L56.7366 18.6081C56.0045 17.8561 54.7267 18.302 54.6136 19.3468L53.622 28.5108Z",
    fill: "#961836"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.231 8.77197C13.266 9.2112 12.3742 9.81681 11.6156 10.5888L1.42673 21.0039C1.13391 21.3034 0.887675 21.6295 0.688024 21.9755C-0.0706475 23.2732 0.641439 24.9437 2.1122 25.2764L16.3739 28.5174L14.231 8.77197Z",
    fill: "#FF8643"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3739 28.5108L8.06841 26.6207C7.11675 26.4078 6.77734 25.2365 7.45615 24.5377L13.2593 18.6081C13.9914 17.8561 15.2691 18.302 15.3823 19.3468L16.3739 28.5108Z",
    fill: "#FFBF9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.e77146b5.svg";
export { ForwardRef as ReactComponent };